<template>
  <div>
      <form @submit.prevent="submitForm()">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                <div class="float-right">
                    <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                    <li class="breadcrumb-item active">Master Data</li>
                    <li class="breadcrumb-item active">{{ $route.name == 'instanceMasterDataCreate' ? 'Tambah' : 'Edit' }}</li>
                    </ol>
                </div>

                <h4 class="page-title">
                    <router-link :to="{ name: 'instanceMasterData' }" :disabled="loading">
                        <i class="fas fa-arrow-left mr-2"></i>
                    </router-link>
                    Master Data
                </h4>
                </div>
            </div>
        </div>

        <div class="card card-loader d-flex" v-if="loadingInitial">
            <div class="justify-content-center">
                <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <p class="mt-2">Loading</p>
            </div>
        </div>

        <div v-else>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group" :class="{ 'is-invalid': $v.masterData.name.$error }">
                                <label for="example-text-input" class="col-form-label text-left d-block">Nama Master Data</label>
                                <input class="form-control" type="text" value="" placeholder="eg. Master Data Tipe Kantin" id="example-text-input"
                                v-model.trim="$v.masterData.name.$model" :disabled="loading">
                                <div class="error" v-if="!$v.masterData.name.required">Nama master data wajib diisi</div>
                                <div class="error" v-if="!$v.masterData.name.minLength">Nama master data minimal 3 karakter</div>
                            </div>
                            <div class="form-group mb-0" :class="{ 'is-invalid': $v.masterData.name.$error }">
                                <label for="example-text-input" class="col-form-label text-left d-block">Tipe Master Data</label>
                                <!-- <input class="form-control" type="text" value="" placeholder="eg. Master Data Tipe Kantin" id="example-text-input"
                                v-model.trim="$v.masterData.name.$model" :disabled="loading"> -->
                                <select v-model.trim="$v.masterData.type.$model" class="form-control">
                                    <option value="GENERAL">GENERAL</option>
                                    <option value="CUSTOMER">CUSTOMER</option>
                                    <option value="SERVICE">SERVICE</option>
                                </select>

                                <div class="error" v-if="!$v.masterData.type.required">Tipe master data wajib diisi</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex">
                <button type="button"
                class="btn btn-primary waves-effect waves-light" style="margin-bottom: 20px; margin-left:auto" @click="addField()" :disabled="loading">
                    <i class="fas fa-plus mr-2"></i>
                    <span>Tambah</span>
                </button>
            </div>

            <draggable
                :list="masterData.items"
                :disabled="!enabled"
                class="list-group"
                ghost-class="ghost"
                v-bind="dragOptions"
                @start="dragging = true"
                @end="dragging = false"
                >

                <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                    <div class="card mb-0 dragable-item" v-for="(item, index) in $v.masterData.items.$each.$iter" :key="index" style="border-bottom: 1px solid #ddd; border-radius: 0px">
                        <div class="card-body">
                            <div class="row align-items-center">
                                <div class="col-1 text-center">
                                    <button type="button"  
                                    :disabled="masterData.items.length <= 1"
                                    class="btn waves-effect waves-light mb-2"
                                    :class="classButton"
                                    @click="removeField(index, item.$model.id)">
                                        <i class="fas fa-trash"></i>
                                    </button>
                                </div>
                                <div class="col-11">
                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            <div class="form-group mb-0" :class="{ 'is-invalid': item.value.$error }">
                                                <label class="form-label text-left">Item</label>
                                                <input class="form-control" type="text" 
                                                v-model.trim="item.value.$model" placeholder="eg. Kantin Makanan" :disabled="loading">
                                                <div class="error" v-if="!item.value.required">Item wajib diisi</div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <div class="form-group mb-0" :class="{ 'is-invalid': item.prefix.$error }">
                                                <label class="form-label text-left">Prefix</label>
                                                <input class="form-control" type="number" 
                                                v-model.trim="item.prefix.$model" placeholder="eg. 0101" :disabled="loading">
                                                <div class="error" v-if="!item.prefix.required">Item wajib diisi</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition-group>

            </draggable>

            <button class="btn btn-success waves-effect waves-light mb-5" style="margin-top: 20px;" :disabled="loading">
                Simpan Master Data
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>
        </div>
      </form>
  </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import draggable from 'vuedraggable'
    import { required, minLength } from 'vuelidate/lib/validators'

    export default {
        data() {
            return {
                loadingInitial: false,
                loading: false,

                masterData: {
                    name: '',
                    type: 'GENERAL',
                    items: [
                        { 
                            id: null,
                            value: '',
                            prefix: '',
                        }
                    ]
                },

                deleted_item_ids: [],

                enabled: true,
                dragging: false,
                drag: false
            };
        },
        validations: {
            masterData: {
                name: {
                    required,
                    minLength: minLength(3)
                },
                type: {
                    required,
                },
                items: {
                    $each:{
                        value: {
                            required
                        },
                        prefix: {}
                    }
                }
            }
        },
        components: {
            draggable
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            classButton() {
                return this.masterData.items.length > 1 ? 'btn-danger' : 'btn-info'
            }
        },
        methods: {
            addField() {
                this.masterData.items.push({
                    id: null,
                    value: '',
                    prefix: '',
                })
            },
            removeField(index, id) {
                Swal.fire({
                title: 'Apakah anda yakin untuk menghapus?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ya, Hapus!'
                }).then((result) => {
                    if (result.value) {
                        this.masterData.items.splice(index, 1)
                        if(id){
                            this.deleted_item_ids.push(id)
                        }
                    }
                })
            },

            submitForm() {
                if (this.$v.masterData.$invalid) {
                    this.$v.$touch()
                    this.sAlert('error', 'Harap isi semua form dengan benar!')
                    return
                }

                this.loading = true

                let url, method, alertSuccess
                if(this.$route.name == 'instanceMasterDataCreate') {
                    url = `master-data/store`
                    method = 'POST',
                    alertSuccess = 'Berhasil membuat template form baru!'
                }else{
                    url = `master-data/update/${this.$route.params.id}`
                    method = 'PUT',
                    alertSuccess = 'Berhasil mengupdate template form!'
                }

                this.$http({
                    method,
                    url: `${this.API_URL}${url}`,
                    data: {...this.masterData, deleted_item_ids: this.deleted_item_ids},
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
                .then(response => {
                    const result = response.data;
                    
                    if(result.success) {
                        this.sAlert('success', alertSuccess)
                        this.$router.push({ name: 'instanceMasterData' });
                    }else {
                        this.sAlert('error', result.message)
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                });
            }
        },
        mounted() {
            if(this.$route.name == 'instanceMasterDataEdit'){
                this.loadingInitial = true

                this.$http.get(`${this.API_URL}master-data/${this.$route.params.id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
                .then(response => {
                    this.loadingInitial = false

                    const result = response.data;
                    
                    if(result.success) {
                        this.masterData.name = result.data.name
                        this.masterData.type = result.data.type
                        this.masterData.items = result.data.items
                    }else {
                        this.sAlert('error', result.message)
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.loadingInitial = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                });
            }
        }
    }
</script>